// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"8522e7bb","132":"6790dc9a","308":"133594eb","435":"31d6cfe0","562":"332db9cd"}[chunkId] + ".chunk.css";
};